/**
 * @generated SignedSource<<ea1951901e1e3cd6b840273d1314b970>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LineItemGroupType = "BOOKING" | "EVENT_REGISTRATION" | "EVENT_SIGN_UP" | "PLAYER" | "TRANSPORTATION";
export type PunchPassCalculationType = "PER_BOOKING" | "PER_SLOT";
export type PunchPassTemplateType = "RATE" | "TRANSPORTATION";
import { FragmentRefs } from "relay-runtime";
export type useInitializePunchPassesFromBooking$data = {
  readonly id: string;
  readonly orders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly lineItemGroups: ReadonlyArray<{
          readonly id: string;
          readonly punchPass: {
            readonly client: {
              readonly fullName?: string;
              readonly id?: string;
            };
            readonly id: string;
            readonly punchPassTemplate: {
              readonly calculationType: PunchPassCalculationType;
              readonly name: string;
              readonly type: PunchPassTemplateType;
            };
            readonly remainingPunchCount: number;
          } | null | undefined;
          readonly punchPassesOthersValid: ReadonlyArray<{
            readonly client: {
              readonly fullName?: string;
              readonly id?: string;
            };
            readonly id: string;
            readonly punchPassTemplate: {
              readonly calculationType: PunchPassCalculationType;
              readonly name: string;
              readonly type: PunchPassTemplateType;
            };
            readonly remainingPunchCount: number;
          } | null | undefined> | null | undefined;
          readonly punchPassesSelfInvalid: ReadonlyArray<{
            readonly client: {
              readonly fullName?: string;
              readonly id?: string;
            };
            readonly id: string;
            readonly punchPassTemplate: {
              readonly calculationType: PunchPassCalculationType;
              readonly name: string;
              readonly type: PunchPassTemplateType;
            };
            readonly remainingPunchCount: number;
          } | null | undefined> | null | undefined;
          readonly punchPassesSelfValid: ReadonlyArray<{
            readonly client: {
              readonly fullName?: string;
              readonly id?: string;
            };
            readonly id: string;
            readonly punchPassTemplate: {
              readonly calculationType: PunchPassCalculationType;
              readonly name: string;
              readonly type: PunchPassTemplateType;
            };
            readonly remainingPunchCount: number;
          } | null | undefined> | null | undefined;
          readonly round: {
            readonly id: string;
            readonly player: {
              readonly id: string;
            } | null | undefined;
          } | null | undefined;
          readonly type: LineItemGroupType;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly ownerClient: {
    readonly id?: string;
  } | null | undefined;
  readonly " $fragmentType": "useInitializePunchPassesFromBooking";
};
export type useInitializePunchPassesFromBooking$key = {
  readonly " $data"?: useInitializePunchPassesFromBooking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitializePunchPassesFromBooking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingPunchCount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "client",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullName",
            "storageKey": null
          }
        ],
        "type": "Customer",
        "abstractKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "punchPassTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calculationType",
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  }
],
v4 = {
  "kind": "Literal",
  "name": "appliesTo",
  "value": "SELF"
},
v5 = {
  "kind": "Literal",
  "name": "valid",
  "value": true
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitializePunchPassesFromBooking",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerClient",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "Customer",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "Member",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Order",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LineItemGroup",
                  "kind": "LinkedField",
                  "name": "lineItemGroups",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "round",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "player",
                          "plural": false,
                          "selections": (v1/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PunchPass",
                      "kind": "LinkedField",
                      "name": "punchPass",
                      "plural": false,
                      "selections": (v3/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": "punchPassesSelfValid",
                      "args": [
                        (v4/*: any*/),
                        (v5/*: any*/)
                      ],
                      "concreteType": "PunchPass",
                      "kind": "LinkedField",
                      "name": "punchPassOptions",
                      "plural": true,
                      "selections": (v3/*: any*/),
                      "storageKey": "punchPassOptions(appliesTo:\"SELF\",valid:true)"
                    },
                    {
                      "alias": "punchPassesOthersValid",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "appliesTo",
                          "value": "OTHERS"
                        },
                        (v5/*: any*/)
                      ],
                      "concreteType": "PunchPass",
                      "kind": "LinkedField",
                      "name": "punchPassOptions",
                      "plural": true,
                      "selections": (v3/*: any*/),
                      "storageKey": "punchPassOptions(appliesTo:\"OTHERS\",valid:true)"
                    },
                    {
                      "alias": "punchPassesSelfInvalid",
                      "args": [
                        (v4/*: any*/),
                        {
                          "kind": "Literal",
                          "name": "valid",
                          "value": false
                        }
                      ],
                      "concreteType": "PunchPass",
                      "kind": "LinkedField",
                      "name": "punchPassOptions",
                      "plural": true,
                      "selections": (v3/*: any*/),
                      "storageKey": "punchPassOptions(appliesTo:\"SELF\",valid:false)"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "178b89fbcd5d2a6a7cb967bfea02ce5e";

export default node;
